import styled from 'styled-components';
import { createUseStyles } from 'react-jss';

export const PlansListStyled = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 20rem;
  gap: 3.2rem;
`;

// To support legacy form modal
const styles = {
  bcForm: { paddingLeft: '2rem' },
};

const createStyles = createUseStyles(styles);
export { createStyles };
